<template>
  <span data-toggle="tooltip" :data-placement="placement" :title="title">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: "Tooltip",
  props: {
    title: {
      required: true,
    },
    placement: {
      default: "top",
      type: String,
    },
  },
};
</script>
